<template>
  <div>
    <div v-if="isSuccess">
      <slot name="content" />
    </div>

    <div
      v-if="isLoading"
      class="flex h-full w-full items-center justify-center"
    >
      <RevSpinner class="h-24 w-24" />
    </div>

    <div v-if="isError">
      <h3 class="heading-3 mt-32">
        {{ i18n(translations.errorTitle) }}
      </h3>
      <p class="body-1 mt-20">
        {{ i18n(translations.errorSubTitle) }}
      </p>
      <RevIllustration
        alt="error"
        class="mx-auto my-0 mt-32 block w-[10.3125rem]"
        :height="130"
        src="/img/ErrorModal.svg"
        :width="165"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevSpinner } from '@ds/components/Spinner'

import translations from './AsyncModalBody.translations'

withDefaults(
  defineProps<{
    isSuccess: boolean
    isLoading: boolean
    isError?: boolean
  }>(),
  {
    isError: false,
    isLoading: false,
    isSuccess: false,
  },
)

const i18n = useI18n()
</script>
